import React, { Component, Fragment } from "react";
import axios from "../../../containers/api";
import { Row, Card, CardBody, CardTitle, Button, Collapse, FormGroup, Label, Input, Badge, ModalBody, Modal, ModalHeader, CustomInput  } from "reactstrap";
import { Colxx, Separator} from "../../../components/common/CustomBootstrap";
import {Table} from "../../../components/table/Table";
import DatePicker, { utils } from "react-modern-calendar-datepicker";
import Config from "../../../constants/config";
import { convertDate, getDayBefore, showCatchError, toEnglishNumbers, getkalas } from "../../../helpers/Utils";
 
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import PrintDriverReserve from "../../../components/print/PrintDriverReserve";

export default class Reserve extends Component {
    constructor(props) {
        super(props);
        this.fileUploader = React.createRef();
        this.state = {
            fromDate:utils('fa').getToday(),// getDayBefore(),
            toDate: utils("fa").getToday(),
            member: JSON.parse(localStorage.getItem("member")),
            DriverCardNumber: "",
            FreighterCardNumber: "",
            collapse: true,
            reserveId: 0,
            driverId: 0,
            reservesSearchResult: [],
            StatusSearchTypes: [
               
                {value: 0, text: 'مجوز باطل شده'},
                {value: 1, text: ' صدور قطعی مجوز'},
                {value: 2, text: 'مجوز چاپ شده'},
                {value: null, text: 'همه'},
             
            ],
            selectedStatusSearchType: { value: null, text: 'همه' },
            searchTitle: "", 
            selectedSenderLists: null,
            CustomerList: [],
            selectedReceiverLists: null,
            kala: null, 
            kalas: [],
            TransportationCompanyList: [],
            TransportationCompany: null,
            RateModal: false,
            RateType: 1,
            Desc: "",
            FileUploadModal: false,
            ShowFileUploadModal: false,
            Type: [
                { value: 0, text: 'بارنامه' },
                { value: 1, text: 'حواله' },
                { value: -1, text: 'انتخاب کنید' }
            ],
            file: null, //uploaded picture
            selectedType: { value: -1, text: 'انتخاب کنید' },
            DriverReserveUploadList: [],
            CityList: [],
            City: null,
        };
    }
    loadLoadHallCity = () => {
        this.props.showSpinner();
        axios.get('api/v1/load-hall-cities/cities')
            .then((res) => {
                //console.log(res.data.data);
                this.props.hideSpinner();
                this.setState({ CityList: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    componentDidMount() {

        this.searchReserves();
        this.loadLoadHallCity();
        if (this.props.memberType.role === 'AdminSupport' || this.props.memberType.role === 'Admin' || this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies')
        {
            this.GetAllTransportationCompany();
           // this.GetAllCustomer();
        }
        else
            //this.GetCustomerByTransportationCompanyId();
        try {
            this.getkalasApi().then(r => console.log(r));
        } catch (err) {
            console.log(err);
        }
    }
    async getkalasApi() {
        try {
            await getkalas()
                .then((res) => this.setState({ kalas: res.data }));
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }
    //checkPermission = () => {
    //    this.props.showSpinner();
    //    axios.get('api/ClientApi/HasAccessTo?permissionName=Reserve_List')
    //        .then((res) => {
    //            if (res.data) {
    //                this.searchReserves();
                  
    //                if (this.state.member.memberType === 'TransportationCompanyAdmin' || this.state.member.memberType === 'TransportationCompanyMember') {
    //                    this.GetCustomerByTransportationCompanyId();
                     
    //                }  
    //            } else {
    //                this.props.history.push('/error404');
    //            }
    //        })
    //        .catch((error) => {
    //            this.props.hideSpinner();
    //            this.props.showAlert(showCatchError(error), "error");
    //        });
    //};
    GetAllTransportationCompany = () => {
        let api = '';
        if (this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies')
            api = 'transportation-company-users/GetByUserId'
        else
            api = 'transportation-companies/GetAll'
        axios.get('/api/v1/' + api)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ TransportationCompanyList: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    searchReserves = () => {
        this.props.showSpinner();

        
        let model = {
            FromDate: convertDate(this.state.fromDate),
            ToDate: convertDate(this.state.toDate),
            DriverCardNumber: this.state.DriverCardNumber,
            FreighterCardNumber: this.state.FreighterCardNumber,
            DriverReserveStatus: this.state.selectedStatusSearchType.value!==null? toEnglishNumbers(this.state.selectedStatusSearchType.value):null,
            ReceiverCustomerId: this.state.selectedReceiverLists !== null ? this.state.selectedReceiverLists.id : null,
            SenderCustomerId: this.state.selectedSenderLists !== null ? this.state.selectedSenderLists.id : null, 
            KalaId: this.state.kala !== null ? this.state.kala.id : null,
            TransportationCompanyId: null,
            LoadHallCityId: this.state.City !== null ? this.state.City.cityId : null, 
        }
        if (this.props.memberType.role === 'AdminSupport' || this.props.memberType.role === 'Admin' || this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies')
            model.TransportationCompanyId = (this.state.TransportationCompany !== null && this.state.TransportationCompany !== undefined) ? this.state.TransportationCompany.transportationCompanyId : null
        axios.post('/api/v1/driver-reservations/SearchDriverReserve', model)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data.length > 0) {
                   
                    this.setState({
                        reservesSearchResult: res.data.data,
                        collapse: false,
                       
                    });
                    //console.log(res.data.data)
                } else {
                    this.setState({reservesSearchResult: []});
                    this.props.showAlert('رزروی یافت نشد.', "warning");
                }
            })
            .catch((error) => {
                console.log(error)
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };

   
        GetCustomerByTransportationCompanyId = () => {
            axios.get('/api/v1/customers/GetCustomerByTransportationCompanyId')
                .then((res) => {
                    this.props.hideSpinner();
                    this.setState({ CustomerList: res.data.data });
                })
                .catch((error) => {
                    this.props.hideSpinner();
                    console.log(error.response);
                    this.props.showAlert(showCatchError(error), "error");
                });
        };
    Print = (Id) => {
        this.printChild.Report_DriverReserve(Id);
        this.searchReserves();
    }
    GetAllCustomer = () => {
        axios.get('/api/v1/customers/GetAllCustomer')
                .then((res) => {
                    this.props.hideSpinner();
                    this.setState({ CustomerList: res.data.data });
                })
                .catch((error) => {
                    this.props.hideSpinner();
                    console.log(error.response);
                    this.props.showAlert(showCatchError(error), "error");
                });
        };
   
    
    resetSearch = () => {
        this.setState({
            fromDate: getDayBefore(),
            toDate: utils("fa").getToday(),
            DriverCardNumber: "",
            FreighterCardNumber: "",
            selectedStatusSearchType: { value: null, text: 'همه' },
            selectedReceiverLists: null, 
            selectedSenderLists: null,
            kala: null, 
            City: null,
        });
        if (this.props.memberType.role === 'AdminSupport' || this.props.memberType.role === 'Admin' || this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies') {
            this.setState({
                TransportationCompany: null,
            })
        }
    }
    async getkalasApi() {
        try {
            await getkalas()
                .then((res) => this.setState({ kalas: res.data }));
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }

   
    CancelReserve = (Id) => { 
        this.props.showSpinner();
        //let model = {
        //    Id:Id,
        //    CancelType: true, 
        //}

        //axios.patch('/api/v1/driver-reservations/CancelReserve', model) 
        axios.patch(`/api/v1/driver-reservations/cancel/${Id}`)
            .then((res) => {
                this.props.hideSpinner();
                this.props.closeSweetAlert();
                this.searchReserves();
                this.props.showAlert(res.data.message, "success");
            })
            .catch((error) => {
                this.props.closeSweetAlert();
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    ReturnTurn = (Id, DriverToFreighterId) => { 
        this.props.showSpinner();
        let model = {
            Id:Id,
            DriverToFreighterId: DriverToFreighterId,
            
        }

        axios.post('/api/v1/driver-turns/ReturnTurn', model) 
            .then((res) => {
                this.props.hideSpinner();
                this.props.closeSweetAlert();
                this.searchReserves();
                this.props.showAlert(res.data.message, "success");
            })
            .catch((error) => {
                this.props.closeSweetAlert();
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };
  
    ReportReserve = (reserveId, format) => {
        let postData = {
            responseType: "arraybuffer"
        }

        this.props.showSpinner();
        axios.get('api/v1/Report/DriverReserveReport?DriverReserveId=' + reserveId + '&Format=' + format, postData)
            .then((res) => {
                this.props.hideSpinner();
                if (format === 'pdf') {
                    let blob = new Blob([res.data], {type: "application/pdf"});
                    let objectUrl = URL.createObjectURL(blob);
                    window.open(objectUrl);
                    this.searchReserves();
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                let decoder = new TextDecoder("utf-8");
                if (error.response != null) {
                    let domString = decoder.decode(error.response.data);
                    if (domString !== null && domString.trim() !== "" && domString.trim() !== undefined) {
                        let msg = domString.replace("-", " ");
                        let msg1 = msg.replace('"', ' ');
                        let msg2 = msg1.replace('"', ' ');
                        this.props.showAlert(msg2, "error");
                    } else {
                        this.props.showAlert("در چاپ خطايی رخ داده است", "error");
                    }
                } else {
                    this.props.showAlert("در چاپ خطايی رخ داده است", "error");
                }
            });
    };

    
    

    closeModal = (modalName) => {
        this.setState({ [modalName]: false });

       
    };

    selectHandleChange = (event, value, name) => {
        this.setState({[name]: value });
    };
    RegisterRate = () => {
        const addModel = {
            Rate: this.state.RateType,
            Desc: this.state.Desc,
            DriverReserveId: this.state.DriverReserveId
        };

        this.props.showSpinner();
        axios.post('api/v1/driversRate/AddDriverRate', addModel)
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    this.props.showAlert(res.data.message, "success");
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    reset = () => {
        this.setState({

            selectedType: { value: -1, text: 'انتخاب کنید' },
            file: null
        })
    }
    GetByDriverReserveId = (DriverReserveId) => {
        this.props.showSpinner();
        axios.get('/api/v1/file-uploads/GetByDriverReserveId?DriverReserveId=' + DriverReserveId)
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    if (res.data.data.length != null && res.data.data.length > 0) {
                        this.setState({ DriverReserveUploadList: res.data.data, DriverReserveMsg: "" });
                        //console.log(res.data.data);
                    } else {
                        this.setState({ DriverReserveUploadList: [], DriverReserveListMsg: "درخواستی وجود ندارد" });
                    }
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error));
                console.log(error.response);
            });
    };
    UploadFile = () => {
        if (this.state.selectedType.value === -1) {
            this.props.showAlert("لطفا نوع مدرک را انتخاب کنید")
        }
        else if (this.state.file === null) {
            this.props.showAlert("لطفا فایل مورد نظر را انتخاب کنید")
        }
        else {
            this.props.showSpinner();
            let result = "";
            switch (this.state.selectedType.value) {
                case 0:
                    result = "bill";
                    break;
                case 1:
                    result = "draft";
                    break;

                default:
            }
            let model = new FormData();
            model.set('FileName', result);
            model.set('Type', toEnglishNumbers(this.state.selectedType.value),);
            model.set('DriverReserveId', this.state.DriverReserveId);
            model.append('File', this.state.file);

            axios.post('/api/v1/file-uploads/AddFileUpload', model, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((res) => {
                this.props.hideSpinner();
                console.log(res.data.data)
                if (res.data.data === null) {
                    this.props.showAlert(res.data.message, "error");
                }
                else {
                    this.setState({ FileUploadModal: false });
                    this.props.showAlert(res.data.message, "success");
                }

            }).catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
        }
    };
    render() {
        const {collapse, toDate, fromDate, DriverCardNumber, FreighterCardNumber, reservesSearchResult} = this.state;

        return (

            <Fragment>
                <PrintDriverReserve
                    onRef={ref => (this.printChild = ref)}
                    showSpinner={this.props.showSpinner}
                    hideSpinner={this.props.hideSpinner}
                    showAlert={this.props.showAlert}
                />
                                <Row>
                    <Colxx xxs="12">
                        <h3> لیست مجوزهای صادر شده برای رانندگان </h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>
                <Row>
                    <Colxx xxs="12" className="mb-4">
                        <Card>
                            <CardBody>
                            <CardTitle>جستجو</CardTitle> 

                                    <div className="p-4 pt-5 border d-flex flex-column">
                                        <div className="d-flex flex-md-row flex-column justify-content-between">
                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>از تاریخ</Label>
                                                <DatePicker
                                                    value={fromDate}
                                                    onChange={(newDate) => {this.setState({fromDate: newDate});}}
                                                    inputPlaceholder="لطفا یک تاریخ انتخاب کنید"
                                                    shouldHighlightWeekends
                                                    inputClassName="form-control"
                                                    locale="fa"
                                                    calendarClassName="calendar"
                                                    colorPrimary={Config.color}
                                                    calendarPopperPosition={'bottom'}
                                                />
                                            </FormGroup>

                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>تا تاریخ</Label>
                                                <DatePicker
                                                    value={toDate}
                                                    onChange={(newDate) => {this.setState({toDate: newDate});}}
                                                    inputPlaceholder="لطفا یک تاریخ انتخاب کنید"
                                                    shouldHighlightWeekends
                                                    inputClassName="form-control"
                                                    locale="fa"
                                                    calendarClassName="calendar"
                                                    colorPrimary={Config.color}
                                                    calendarPopperPosition={'bottom'}
                                                />
                                            </FormGroup>

                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>شماره هوشمند راننده</Label>
                                                <Input value={DriverCardNumber} onChange={(e) => this.setState({DriverCardNumber: e.target.value})}/>
                                            </FormGroup>

                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>شماره هوشمند ناوگان</Label>
                                                <Input value={FreighterCardNumber} onChange={(e) => this.setState({FreighterCardNumber: e.target.value})}/>
                                            </FormGroup>
                                        </div>
                                            <div className="d-flex flex-md-row flex-column justify-content-between">

                                            
                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>وضعیت</Label>
                                                <Autocomplete
                                                    disableClearable
                                                    clearText={"حذف"}
                                                    closeText={"بستن"}
                                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                                    openText={"باز کردن"}
                                                    className="react-select__control"
                                                    id="selectedStatusSearchType"
                                                    options={this.state.StatusSearchTypes}
                                                    getOptionLabel={(option) => option.text}
                                                    value={this.state.selectedStatusSearchType}
                                                    onChange={(e, v) => this.selectHandleChange(e, v, "selectedStatusSearchType")}
                                                    renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                />
                                            </FormGroup>
                                            
                                                    {/* <FormGroup className="w-md-25 w-100 px-1">
                                                        <Label>فرستنده</Label>
                                                        <Autocomplete
                                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                                            openText={"باز کردن"}
                                                            className="react-select__control"
                                                            id="selectedSenderLists"
                                                            options={this.state.CustomerList}
                                                    getOptionLabel={(option) => option.customerFullName + ' (' + option.meliCode + ')'}
                                                            value={this.state.selectedSenderLists}
                                                            onChange={(e, v) => this.selectHandleChange(e, v, "selectedSenderLists")}
                                                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                                        />
                                                    </FormGroup> */}

                                                    {/* <FormGroup className="w-md-25 w-100 px-1">
                                                        <Label>گیرنده</Label>
                                                        <Autocomplete
                                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                                            openText={"باز کردن"}
                                                            className="react-select__control"
                                                            id="selectedReceiverLists"
                                                            options={this.state.CustomerList}
                                                    getOptionLabel={(option) => option.customerFullName + ' (' + option.meliCode + ')'}
                                                            value={this.state.selectedReceiverLists}
                                                            onChange={(e, v) => this.selectHandleChange(e, v, "selectedReceiverLists")}
                                                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                                        />
                                                    </FormGroup> */}
                                                
                                            

                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>نوع محموله</Label>
                                                <Autocomplete
                                                    clearText={"حذف"}
                                                    closeText={"بستن"}
                                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                                    openText={"باز کردن"}
                                                    className="react-select__control"
                                                    id="kala"
                                                    options={this.state.kalas}
                                                    getOptionLabel={(option) => option.kalaDesc}
                                                    value={this.state.kala}
                                                    onChange={(e, v) => this.selectHandleChange(e, v, "kala")}
                                                    renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                />
                                            </FormGroup>
                                        </div>
                                        
                                            <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap">
                                        {(this.props.memberType.role === 'AdminSupport' || this.props.memberType.role === 'Admin' || this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies') &&
                                            <FormGroup className="w-md-25 w-100 px-1">
                                                    <Label>شركت های حمل و نقل</Label>
                                                    <Autocomplete
                                                        clearText={"حذف"}
                                                        closeText={"بستن"}
                                                        noOptionsText={"در حال دریافت اطلاعات.."}
                                                        openText={"باز کردن"}
                                                        className="react-select__control"
                                                        id="TransportationCompany"
                                                        options={this.state.TransportationCompanyList}
                                                        getOptionLabel={(option) => option.transportationCompanyName}
                                                        value={this.state.TransportationCompany}
                                                        onChange={(e, v) => this.selectHandleChange(e, v, "TransportationCompany")}
                                                        renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                    />
                                                </FormGroup> }
                                          {(this.props.memberType.role === 'AdminSupport' || this.props.memberType.role === 'Admin' || this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies') &&
                                    <FormGroup className="w-md-25 w-100 px-1">
                                        <Label>شهر</Label>
                                        <Autocomplete
                                            clearText={"حذف"}
                                            closeText={"بستن"}
                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                            openText={"باز کردن"}
                                            className="react-select__control"
                                            id="City"
                                            options={this.state.CityList}
                                            getOptionLabel={(option) => option.cityName}
                                            value={this.state.City}
                                            onChange={(e, v) => this.selectHandleChange(e, v, "City")}
                                            renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                        />
                                        </FormGroup>
                                        }
                                        <FormGroup className="w-md-25 w-100 px-1"> </FormGroup>
                                        <FormGroup className="w-md-25 w-100 px-1"> </FormGroup>
                                    </div>
                                        <div className="d-flex mt-2 justify-content-center">
                                            <FormGroup className="text-center">
                                                <Button color="primary" className="btn-lg mx-2" onClick={this.searchReserves}>
                                                    جستجو
                                                </Button>
                                            </FormGroup>
                                            <FormGroup className="text-center">
                                                <Button color="primary" className="btn-lg mx-2" onClick={this.resetSearch}>
                                                    پاک کردن
                                                </Button>
                                            </FormGroup>
                                        </div>
                                    </div>

                                {this.state.searchTitle !== "" ?
                                    <CardTitle className="d-flex w-100 justify-content-md-start justify-content-center mt-5"> نتایج جستجو ({this.state.searchTitle})</CardTitle>
                                    :
                                    null
                                }

                                {reservesSearchResult ?
                                    <Table
                                        tableHeaders={[
                                            "شناسه",
                                            "شناسه بار",
                                            "وضعیت",
                                            "شركت حمل و نقل",
                                           // "فرستنده",
                                           // "گیرنده", 
                                            "نام راننده",
                                            "موبایل",
                                            "هوشمند راننده",
                                            "هوشمند ماشين",
                                            "پلاک", 
                                            "محموله", 
                                            "تاریخ رزرو",
                                            "زمان رزرو",
                                            "برگشت نوبت", 
                                            "چاپ",
                                            "لغو", 
                                            // "امتیاز دهی",
                                            "بارگزاری مدارک",
                                            "نمایش مدارک",
                                        ]}

                                        tableRow={this.state.reservesSearchResult}

                                        tableData={[
                                            reserve => {
                                                return reserve.id;
                                            },
                                            reserve => {
                                                return reserve.cargoId;
                                            },
                                            reserve => {
                                                switch (reserve.status) {
                                                    case 0:
                                                        return <Badge color="outline-danger" pill>مجوز باطل شده</Badge>;
                                                    case 1:
                                                        return <Badge color="outline-warning" pill>صدور قطعی مجوز</Badge>;
                                                     case 2:
                                                        return <Badge color="outline-warning" pill>مجوز چاپ شده</Badge>;
                                                     case 3:
                                                        return <Badge color="outline-warning" pill>بارگذاری حواله توسط پشتیبان</Badge>;
                                                       case 4:
                                                        return <Badge color="outline-warning" pill>بارگذاری بارنامه توسط پشتیبان</Badge>;
                                                       case 5:
                                                        return <Badge color="outline-warning" pill>تحوِل بار</Badge>;
                                                         case 6:
                                                        return <Badge color="outline-warning" pill>اتمام بارگیری</Badge>;
                                                       
                                                     
                                                }
                                            },
                                            reserve => {
                                                return reserve.transportationCompanyName !== null && reserve.transportationCompanyName;
                                            },
                                            // reserve => {
                                            //     return reserve.senderCustomerName;
                                            // },
                                            // reserve => {
                                            //     return reserve.receiverCustomerName;
                                            // },
                                            
                                            reserve => {
                                                return reserve.driverName + " " + reserve.driverFamily;
                                            },
                                            reserve => {
                                                return reserve.driverMobile;
                                            },
                                            reserve => {
                                                return reserve.driverCardNumber;
                                            },
                                            reserve => {
                                                return reserve.freighterCardNumber;
                                            },
                                            reserve => {
                                                return reserve.plaque  
                                            },
                                             
                                            reserve => {
                                                return reserve.kalaDesc;
                                            },
                                            reserve => {
                                                return reserve.driverReserveDate;
                                            },
                                            reserve => {
                                                return reserve.driverReserveTime;
                                            },
                                           
                                            reserve => {
                                                if (reserve.status === 0 && (reserve.driverTurnId !== null && reserve.driverTurnId !== 0) && this.props.memberType.role === 'Admin'  ) {
                                                    return (
                                                        <Button outline color="primary" size="sm"
                                                            onClick={() => this.props.showSweetAlert("آیا این نوبت برگشت داده شود؟", "", "danger", () => this.ReturnTurn(reserve.id, reserve.driverToFreighterId))}>
                                                            برگشت نوبت
                                                        </Button>
                                                    )
                                                }
                                            },
                                             
                                            //reserve => {
                                            //    if (reserve.status !== 0 && (reserve.status === 1 || reserve.status === 2) ) {
                                            //        return (
                                            //            <Button outline color="primary" size="sm"
                                            //                    onClick={() => this.ReportReserve(reserve.id, 'pdf')}>
                                            //                چاپ
                                            //            </Button>
                                            //        )
                                            //    }
                                            //}, 
                                            reserve => {
                                                return (
                                                    (reserve.status !== 0 && (reserve.status === 1 || reserve.status === 2 )) &&
                                                    <Button outline color="info" size="sm"
                                                            onClick={() => this.Print(reserve.id)}>
                                                            چاپ  
                                                    </Button>
                                                );
                                            },
                                          
                                            reserve => {
                                                if ((reserve.status === 1 || reserve.status === 2) && this.props.memberType.role === 'Admin' ) {
                                                    return (
                                                        <Button outline color="danger" size="sm"
                                                            onClick={() => this.props.showSweetAlert("آیا این رزرو باطل شود؟", "", "danger", () => this.CancelReserve(reserve.id))}>
                                                            حذف
                                                        </Button>
                                                    )
                                                }
                                            },
                                            // reserve => {
                                            //     return (
                                            //         <Button outline color="success" className="mx-3 my-md-0 my-1"
                                            //             onClick={() => this.setState({ RateModal: true, DriverReserveId: reserve.id, Desc: "", RateType: 1 })}>
                                            //             امتیازدهی
                                            //         </Button>


                                            //     )


                                            // },
                                            reserve => {
                                                return (
                                                    <Button outline color="primary" size="sm"
                                                        onClick={() => this.setState({ DriverReserveId: reserve.id, FileUploadModal: true }, () => this.reset()
                                                        )}>
                                                        بارگزاری مدارک
                                                    </Button>

                                                )
                                            },
                                            reserve => {
                                                return (
                                                    <Button outline color="primary" size="sm"
                                                        onClick={() => this.setState({ ShowFileUploadModal: true }, () => this.GetByDriverReserveId(reserve.id)
                                                        )}>
                                                        نمایش مدارک
                                                    </Button>

                                                )
                                            }
                                        ]}
                                    />
                                    :
                                    null
                                }
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>


                 

                <Modal isOpen={this.state.FileUploadModal} toggle={() => this.setState({ FileUploadModal: false })} size="xlg">
                    <ModalHeader toggle={() => this.setState({ FileUploadModal: false })}>
                        {this.state.DriverReserveMsg}
                    </ModalHeader>
                    <ModalBody className="d-flex flex-md-row flex-column justify-content-center align-items-end flex-wrap w-100 mt-5">

                        <div className="p-4 pt-5 border d-flex flex-column">
                            <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap">

                                <FormGroup className="w-md-100 w-100 px-1">
                                    <Label>نوع مدرک</Label>
                                    <Autocomplete
                                        disableClearable
                                        clearText={"حذف"}
                                        closeText={"بستن"}
                                        noOptionsText={"در حال دریافت اطلاعات.."}
                                        openText={"باز کردن"}
                                        className="react-select__control"
                                        id="selectedType"
                                        options={this.state.Type}
                                        getOptionLabel={(option) => option.text}
                                        value={this.state.selectedType}
                                        onChange={(e, v) => this.selectHandleChange(e, v, "selectedType")}
                                        renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                    />

                                </FormGroup>



                            </div>

                            <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap">


                                <FormGroup className="w-md-100 w-100 mx-1">
                                    <label className="form-title">
                                        تصویر</label>

                                    <input
                                        style={{ cursor: "cell" }}
                                        className="input" value={this.state.file !== null ? this.state.file.name : "لطفا یک فایل انتخاب کنید"}
                                        onClick={() => this.fileUploader.current.click()} />
                                    <input
                                        ref={this.fileUploader}
                                        style={{ display: "none" }} type="file"
                                        onChange={(e) => {
                                            this.setState({ file: e.target.files[0] });
                                        }}
                                    />
                                </FormGroup>
                            </div>

                            <div className="d-flex mt-2 justify-content-center">
                                <FormGroup className="text-center">
                                    <Button color="primary" className="btn-lg mx-2" onClick={this.UploadFile}>
                                        ثبت
                                    </Button>
                                </FormGroup>

                            </div>
                        </div>


                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.RateModal} size="xlg" toggle={() => this.closeModal("RateModal")}>
                    <ModalHeader toggle={() => this.closeModal("RateModal")}>
                        امتیازدهی
                    </ModalHeader>
                    <ModalBody>
                        <div className="d-flex flex-md-row flex-column flex-wrap justify-content-around align-items-center w-25">
                            <CustomInput
                                lassName="w-md-20 w-50"
                                type="radio"
                                id="RateType1"
                                name="RateType"
                                label="1"
                                checked={this.state.RateType === 1}
                                onChange={() => this.setState({ RateType: 1 })}
                            />
                            <CustomInput
                                lassName="w-md-20 w-50"
                                type="radio"
                                id="RateType2"
                                name="RateType"
                                label="2"
                                checked={this.state.RateType === 2}
                                onChange={() => this.setState({ RateType: 2 })}
                            />
                            <CustomInput
                                lassName="w-md-20 w-50"
                                type="radio"
                                id="RateType3"
                                name="RateType"
                                label="3"
                                checked={this.state.RateType === 3}
                                onChange={() => this.setState({ RateType: 3 })}
                            />
                            <CustomInput
                                className="w-md-20 w-50"
                                type="radio"
                                id="RateType4"
                                name="RateType"
                                label="4"
                                checked={this.state.RateType === 4}
                                onChange={() => this.setState({ RateType: 4 })}
                            />
                            <CustomInput
                                className="w-md-20 w-50"
                                type="radio"
                                id="RateType5"
                                name="RateType"
                                label="5"
                                checked={this.state.RateType === 5}
                                onChange={() => this.setState({ RateType: 5 })}
                            />
                        </div>
                        <FormGroup className="w-md-30 w-100 px-1">
                            <Label>توضیحات</Label>
                            <Input value={this.state.Desc}
                                onChange={(e) => this.setState({ Desc: e.target.value })} />
                        </FormGroup>
                        <FormGroup className="w-md-30 w-100 px-1">

                            <Button color="primary" className="btn-lg mx-2"
                                onClick={() => this.RegisterRate()}>
                                ثبت امتیاز
                            </Button>
                        </FormGroup>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.ShowFileUploadModal} toggle={() => this.setState({ ShowFileUploadModal: false })} size="xlg">
                    <ModalHeader toggle={() => this.setState({ ShowFileUploadModal: false })}>
                        {this.state.DriverReserveListMsg}
                    </ModalHeader>
                    <ModalBody className="d-flex justify-content-center">

                        <Table
                            tableHeaders={[
                                "نوع",
                                "تاریخ ثبت",
                                "ساعت ثبت",
                                "مدرک",

                            ]}

                            tableRow={this.state.DriverReserveUploadList}

                            tableData={[
                                x => {
                                    switch (x.type) {

                                        case 0:
                                            return <Badge color="outline-danger" pill>بانامه</Badge>
                                        case 1:
                                            return <Badge color="outline-secondary" pill>حواله</Badge>

                                    }
                                },
                                x => {
                                    return x.date
                                },
                                x => {
                                    return x.time
                                },
                                x => {
                                    return <a target="_blank"
                                        href={Config.url + "UploadFile/" + toEnglishNumbers(x.fileName)}><img
                                            alt="" width="50px" height="50px"
                                            src={Config.url + "UploadFile/" + toEnglishNumbers(x.fileName)} /></a>;
                                },
                            ]} />


                    </ModalBody>
                </Modal>
                 
            </Fragment>
        )
    }
}
